module.exports = __webpack_public_path__ + "img/scjr-jrcp.1e008161.jpg";